import { render } from "./productBoxList.vue?vue&type=template&id=df406b82&ts=true"
import script from "./productBoxList.vue?vue&type=script&lang=ts"
export * from "./productBoxList.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__